module.exports = __webpack_public_path__ + "img/btn.42cf1a02.png";